import { render } from "./PattyPanel.vue?vue&type=template&id=4ebcfc8f&scoped=true"
import script from "./PattyPanel.vue?vue&type=script&lang=js"
export * from "./PattyPanel.vue?vue&type=script&lang=js"

import "./PattyPanel.vue?vue&type=style&index=0&id=4ebcfc8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebcfc8f"]])

export default __exports__